/* Galaxy "innovaccer galaxy" wordmark + gradient mark, exported from the Figma
   source (node 268:3783). The "galaxy" wordmark uses PolySans Bulky — a weight
   the Seasons @font-face set does not ship — so it is rendered as an image
   rather than live text, matching the FlowLogo / CometLogo approach. The mark
   is white-on-transparent, designed for the dark Galaxy nav + footer. */
export function GalaxyLogo({ height = 40, className }: { height?: number; className?: string }) {
  return (
    <img
      src="/media/galaxy/logo-galaxy-wordmark.png"
      alt="innovaccer galaxy"
      className={className}
      style={{ height, width: 'auto', display: 'block' }}
      draggable={false}
    />
  )
}

export default GalaxyLogo
